import { USER_ROLE_LABELS } from '../admin/users/types';

import type { RoutingRuleDto } from './types';

/**
 * Rótulos da tela Times & Roteamento (noturna 04/Set/2026).
 *
 * A-02: o seletor «Adicionar membro» mostrava o papel como enum cru — «(admin_tenant)»,
 * «(dpo_tenant)» — enquanto a tela de Usuários já traduz. Um mapa, dois lugares.
 *
 * A-03: a coluna «TIME DESTINO» mostrava «—» para a regra semeada «Entrada → Recepção»,
 * que roteia para um PLAYBOOK (`decisionPlaybookId`), não para um time. O «—» era
 * correto e cego: a tabela não sabia dizer para onde a regra manda.
 */
export function memberOptionLabel(user: { name: string; primaryRole: string }): string {
  return `${user.name} · ${USER_ROLE_LABELS[user.primaryRole] ?? user.primaryRole}`;
}

export function ruleDestinationLabel(
  rule: Pick<RoutingRuleDto, 'decisionTargetTeamId' | 'decisionPlaybookId'>,
  teamNameById: ReadonlyMap<string, string>,
  playbookNameById: ReadonlyMap<string, string>,
): string {
  const parts: string[] = [];
  if (rule.decisionTargetTeamId !== null) {
    parts.push(`time ${teamNameById.get(rule.decisionTargetTeamId) ?? rule.decisionTargetTeamId}`);
  }
  if (rule.decisionPlaybookId !== null) {
    parts.push(
      `playbook ${playbookNameById.get(rule.decisionPlaybookId) ?? rule.decisionPlaybookId}`,
    );
  }
  return parts.length > 0 ? parts.join(' · ') : 'sem destino';
}
